import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataService,
    HttpUrlGenerator,
    DefaultDataServiceConfig
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { BudgetCycle } from './budget-cycle.model';
import { EfaactDataService } from '../efaact.data-service';
export const entityName = 'BudgetCycle';

@Injectable()
export class BudgetCycleDataService extends EfaactDataService<BudgetCycle> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
    mapItems(item: BudgetCycle): BudgetCycle {
        return {
            ...item,
            id: item.Budgetcycleid
        };
    }
}
